import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SimulatorComponent } from './simulator/simulator.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { CustomLabelComponent } from './custom-label/custom-label.component';
import { AuthGuard } from '../guards/auth.guard';
import { RoleRedirectGuard } from '../guards/role.guard';
import { MenuAccessGuard } from '../guards/menu-access.guard';

const routes: Routes = [
  { path: 'simulator', component: SimulatorComponent, canActivate: [AuthGuard, RoleRedirectGuard, MenuAccessGuard] },
  { path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuard, RoleRedirectGuard, MenuAccessGuard] },
  { path: 'custom-label', component: CustomLabelComponent, canActivate: [AuthGuard, RoleRedirectGuard, MenuAccessGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeaturePagesRoutingModule { }
